import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    classificationData: null,
    error: null,
    loading: false,
    insertData: null,
    updateData: null,
    deleteData: null,
    errorInsert: null,
    errorUpdate: null,
    errorDelete: null,
};

const classificationSlice = createSlice({
    name: "classification",
    initialState,
    reducers: {
        getDataAll: (state) => {
            state.loading = true;
        },
        getDataAllSuccess: (state, action) => {
            state.loading = false;
            state.classificationData = action.payload;
            state.error = null;
        },
        getDataAllFail: (state, action) => {
            state.loading = false;
            state.classificationData = null;
            state.error = action.payload;
        },
        addClassification: (state) => {
            state.loading = true;
            state.insertData = null;
            state.errorInsert = null;
        },
        addClassificationSuccess: (state, action) => {
            state.loading = false;
            state.insertData = action.payload;
            state.errorInsert = null;
        },
        addClassificationFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.insertData = null;
        },
        updateClassification: (state) => {
            state.loading = true;
        },
        updateClassificationSuccess: (state, action) => {
            state.loading = false;
            state.updateData = action.payload;
            state.error = null;
        },

        updateClassificationFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        deleteClassification: (state) => {
            state.loading = true;
        },
        deleteClassificationSuccess: (state, action) => {
            state.loading = false;
            state.deleteData = action.payload;
            state.error = null;
        },
        deleteClassificationFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        setDataNull: (state) => {
            state.error = null;
            state.insertData = null;
            state.updateData = null;
            state.deleteData = null;
            state.errorInsert = null;
            state.errorUpdate = null;
            state.errorDelete = null;
        },
    },
});

export const {
    getDataAll,
    getDataAllSuccess,
    getDataAllFail,
    addClassification,
    addClassificationSuccess,
    addClassificationFail,
    updateClassification,
    updateClassificationSuccess,
    updateClassificationFail,
    deleteClassification,
    deleteClassificationSuccess,
    deleteClassificationFail,

    setDataNull,
} = classificationSlice.actions;

export default classificationSlice.reducer;
